export default __webpack_public_path__ + "static/media/mpp-icon-48px.78e279dd.svg";